import { Component } from '@angular/core';
import { TokenRefreshService } from './services/token-refresh.service';
import { AuthService } from './services/auth.service';
import { Profile } from 'src/app/models/profile.model';
import { LiveChatService } from './services/live-chat.service';
import { ProfileService } from './services/profile.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  profileData!: Profile;
  signature: string = '';

  constructor(
    private authService: AuthService,
    private tokenRefreshService: TokenRefreshService,
    private liveChatService: LiveChatService,
    private profileService: ProfileService,
  ) { }

  title: string = 'Collaborator Komerce';
  isAppReady: boolean = false;

  ngOnInit() {
    this.liveChatService.initialize();
    const token = localStorage.getItem('auth-token');
    if (token) {
      this.authService.refreshToken().subscribe({
        next: () => {
          this.tokenRefreshService.startTokenRefresh();
          this.profileService.getProfile();
          this.isAppReady = true;
        },
        error: () => {
          this.isAppReady = true;
          this.authService.logout();
        }
      });
    } else {
      this.isAppReady = true;
    }
  }
}
